module.exports = __webpack_public_path__ + "media/images/snack-logo-black-7c67fd1ac8111b5e9529645ce507999d.png";